import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { ButtonPrimary, ButtonSecondary } from '@klarna/bubble-ui';

const Button = ({ type, ...props }) => {
  switch (type) {
    case 'primary':
      return <ButtonPrimary {...props} />;
    case 'quaternary':
      return <ButtonSecondary {...props} />;
    default:
      return null;
  }
};

Button.propTypes = {
  type: PropTypes.oneOf(['primary', 'quaternary']),
};

export default Button;
